module.exports = [
  {
    "COD": "Cancer",
    "Geography": "Metro New Orleans",
    "Year": "1999-2001",
    "Rate": 242.07
  },
  {
    "COD": "Cancer",
    "Geography": "Metro New Orleans",
    "Year": "2002-2004",
    "Rate": 230
  },
  {
    "COD": "Cancer",
    "Geography": "Metro New Orleans",
    "Year": "2005-2007",
    "Rate": 200.47
  },
  {
    "COD": "Cancer",
    "Geography": "Metro New Orleans",
    "Year": "2008-2010",
    "Rate": 201.77
  },
  {
    "COD": "Cancer",
    "Geography": "Metro New Orleans",
    "Year": "2011-2013",
    "Rate": 190.3
  },
  {
    "COD": "Cancer",
    "Geography": "Metro New Orleans",
    "Year": "2014-2016",
    "Rate": 173.03
  },
  {
    "COD": "Cancer",
    "Geography": "Metro New Orleans",
    "Year": "2017-2018",
    "Rate": 163.05
  },
  {
    "COD": "Cancer",
    "Geography": "United States",
    "Year": "1999-2001",
    "Rate": 203.8
  },
  {
    "COD": "Cancer",
    "Geography": "United States",
    "Year": "2002-2004",
    "Rate": 195.33
  },
  {
    "COD": "Cancer",
    "Geography": "United States",
    "Year": "2005-2007",
    "Rate": 186.67
  },
  {
    "COD": "Cancer",
    "Geography": "United States",
    "Year": "2008-2010",
    "Rate": 178.73
  },
  {
    "COD": "Cancer",
    "Geography": "United States",
    "Year": "2011-2013",
    "Rate": 170.6
  },
  {
    "COD": "Cancer",
    "Geography": "United States",
    "Year": "2014-2016",
    "Rate": 162.87
  },
  {
    "COD": "Cancer",
    "Geography": "United States",
    "Year": "2017-2018",
    "Rate": 154.85
  }
]
